import React from "react";

export const TUTORIAL_INPUT_CLASS =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-violet-400 focus:ring-4 focus:ring-violet-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-violet-500 dark:focus:ring-violet-900/40";

export function FormSection({
  title,
  description,
  children,
}) {
  return (
    <section className="rounded-[26px] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-6">
      <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-50">
        {title}
      </h3>

      {description ? (
        <p className="mt-1 text-sm leading-6 text-slate-500 dark:text-slate-400">
          {description}
        </p>
      ) : null}

      <div className="mt-5">
        {children}
      </div>
    </section>
  );
}

export function Field({
  children,
  className = "",
}) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

export function Label({
  children,
  required = false,
}) {
  return (
    <label className="mb-2 block text-sm font-semibold text-slate-700 dark:text-slate-200">
      {children}

      {required ? (
        <span className="ml-1 text-rose-500">
          *
        </span>
      ) : null}
    </label>
  );
}

export function ToggleCard({
  name,
  checked,
  onChange,
  title,
  description,
}) {
  return (
    <label className="flex cursor-pointer items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-4 transition hover:border-violet-300 dark:border-slate-700 dark:bg-slate-800/50 dark:hover:border-violet-700">
      <div>
        <div className="font-semibold text-slate-900 dark:text-slate-50">
          {title}
        </div>

        {description ? (
          <div className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
            {description}
          </div>
        ) : null}
      </div>

      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        className="h-5 w-5 shrink-0 rounded border-slate-300 text-violet-600 focus:ring-violet-500 dark:border-slate-600 dark:bg-slate-800"
      />
    </label>
  );
}